import { GetText, gettext_noop } from 'shared/i18n'
import { LoginFailureCode } from 'shared/auth'

const MESSAGES = {
  [LoginFailureCode.INVALID_CREDENTIALS]: gettext_noop(
    `We were unable to log you in. If your account has been approved and you've clicked the link in the email to activate it, please ensure you've typed your email and password correctly.`,
  ),
}

type LoginFailureProps = {
  code: LoginFailureCode
}

export default function LoginFailure(props: LoginFailureProps) {
  return (
    <p className="rounded bg-red-50 px-4 py-4 text-red-600">
      <GetText>{MESSAGES[props.code]}</GetText>
    </p>
  )
}
